import { inject, Injectable } from '@angular/core';
import { CallOptions, createClient } from '@connectrpc/connect';
import { BaseGrpcService } from './base-grpc.service';
import { Price, PricingService } from './gen/pricing_pb';
import { GRPC_TRANSPORT } from './grpc-transport';
import { grpcPricingToPricingItem } from './helpers';
import { PricingItem } from './pricing.model';

@Injectable({ providedIn: 'root' })
export class PricingGrpcService extends BaseGrpcService<PricingItem, Price> {
  private readonly client = createClient(PricingService, inject(GRPC_TRANSPORT));
  protected override readonly transformFn = grpcPricingToPricingItem;

  protected override openStream(options: CallOptions) {
    return this.client.subscribe({}, options);
  }
}
